'use client';
/**
 * CL 지역 문서 11 — 카톡방 1(차분한 아웃라인 버튼). 계측은 기존 talk 슬롯 규격(trackTalkView·trackTalkClick, slot 'inline').
 * ⛔ 이모지·전화번호 없음. 페이지당 1회만 렌더한다(호출부 RegionDoc 한 곳).
 */
import { useEffect, useRef } from 'react';
import { KAKAO_TALK_URL, trackTalkClick, trackTalkView } from '@/lib/talk-banner';
import { TalkLiveLabel, TALK_LIVE_LABEL } from '@/components/live/LiveBadge';

export default function RegionTalk({ place, slug }: { place: string; slug: string }) {
  const ref = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) {
        trackTalkView('inline', { site_slug: slug, surface: 'region_doc' });
        io.disconnect();
      }
    }, { threshold: [0.5] });
    io.observe(el);
    return () => io.disconnect();
  }, [slug]);
  return (
    <a
      ref={ref}
      className="rdoc-talk kd-lv-host"
      href={KAKAO_TALK_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackTalkClick('inline', { site_slug: slug, surface: 'region_doc' })}
    >
      {/* nav-live(2026-10-24) — 「카톡방 입장」 → 「실시간 소통」 + LIVE 표지(상세 하단 바와 같은 한 벌). */}
      <TalkLiveLabel label={`${place} 분양 소식 ${TALK_LIVE_LABEL}`} />
    </a>
  );
}
